<template lang="pug">
  v-container(fluid).pa-0.py-12
    v-img(height='50vh' :src='Nosotros.encabezado.imagen')
      v-container
        v-row( justify='start' align='start' ).py-10.mt-10           
          p.text-uppercase.display-1.font-weight-bold.mx-12.white--text.icono-international.icono-grande( v-html='Nosotros.encabezado.titulo').pt-7.pl-7

</template>

<script>
import  moment from 'moment'
export default {
  data:  ()=>({
    inicio: '29/05/2020',
    fin: '5/06/2020',
    avance: null,
    numero: 100 
  }),
  computed: {
    Construccion() {
      return this.$contenido.Construccion || {}
    },
    Nosotros() {
      return this.$contenido.Nosotros || {}
    },
  },
  created() {
    setInterval( ()=>{
      let t=moment.duration( moment(this.fin, 'DD/MM/YYYY').subtract(moment()))
      this.avance = `${t.days()} día, ${t.hours()}: ${t.minutes()}:${t.seconds()}`
      const total = moment.duration( moment(this.fin, 'DD/MM/YYYY').subtract(moment(this.inicio,'DD/MM/YYYY')))
      this.numero = total.asSeconds()/ t.asSeconds()}, 1000)
    
	
    }
  
}
</script>